<ng-template #optonsAcciones let-offcanvas>
    <div class="offcanvas-header">
        <div class="w-100">
            <div class="col-12">
                <div class="row">
                    <div class="col-10">
                        <div class="h5 text-secondary mt-2">
                            <i class="fas fa-university me-2 text-primary"></i>
                            Seleccione la cuenta destino
                        </div>
                    </div>
                    <div class="col-2 text-end pt-2">
                        <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="offcanvas-body">
        <div class="row">
            <div class="col-12">

                <!-- Campo de búsqueda -->
                <div class="mb-3">
                    <div class="input-group">
                        <span class="input-group-text bg-light border-end-0">
                            <i class="fas fa-search text-muted"></i>
                        </span>
                        <input
                            type="text"
                            class="form-control border-start-0"
                            placeholder="Buscar por banco, número de cuenta, RIF..."
                            [(ngModel)]="searchTerm"
                            (input)="filterAccounts()"
                            style="box-shadow: none;">
                    </div>
                </div>

                <ng-container *ngIf="accountPayment_load">
                    <div class="w-100 text-center py-5">
                        <div class="spinner-border text-primary mb-3" role="status">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                        <h6 class="text-muted">Cargando cuentas disponibles...</h6>
                        <p class="text-muted small mb-0">Por favor espera un momento</p>
                    </div>
                </ng-container>

                <div class="mt-2" *ngIf="!accountPayment_load && (!filteredAccounts || filteredAccounts.length < 1)">
                    <div class="text-center py-4">
                        <i class="fas fa-search fa-3x text-muted mb-3"></i>
                        <h6 class="text-muted">No se encontraron resultados</h6>
                        <p class="text-muted small">Intenta con otro término de búsqueda o código</p>
                    </div>
                </div>

                <div *ngIf="!accountPayment_load && filteredAccounts && filteredAccounts.length > 0">
                    <!-- Header con contador -->
                    <div class="d-flex align-items-center justify-content-between mb-3 p-2 bg-light rounded">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-credit-card text-primary me-2"></i>
                            <span class="fw-bold text-dark">Cuentas Disponibles</span>
                        </div>
                        <span class="badge bg-primary">
                            {{cuentasVisibles.length}} cuenta{{cuentasVisibles.length > 1 ? 's' : ''}}
                        </span>
                    </div>

                    <!-- Filtro por empresa (solo visual) -->
                    <div class="d-flex flex-wrap gap-1 mb-2">
                        <button type="button" class="empresa-chip" *ngFor="let e of [['Todas','Todas'],['MT','Mundo Total'],['CT','CrediTotal']]" [class.activo]="empresaFiltro === e[1]" [title]="e[1]" (click)="setEmpresaFiltro($any(e[1]))">{{ e[0] }}</button>
                    </div>

                    <div class="text-muted mb-2" style="font-size:.75rem" *ngIf="cuentasVisibles.length < 1">
                        Sin cuentas {{ empresaFiltro === 'CrediTotal' ? 'CT' : 'MT' }}. <button type="button" class="empresa-chip" (click)="setEmpresaFiltro('Todas')">Ver Todas</button>
                    </div>

                    <div class="row g-3">
                        <div class="col-12" *ngFor="let item of cuentasVisibles">
                            <div
                                class="card border-2 cursor-pointer transition-all hover-shadow account-card"
                                [ngClass]="{'border-primary bg-primary-subtle': account?.code == item?.code, 'border-light hover-border-primary': account?.code != item?.code}"
                                (click)="selectAccount(item)">
                                <div class="card-body p-3">
                                    <!-- Header de la cuenta con mejor alineación -->
                                    <div class="d-flex align-items-start justify-content-between mb-3">
                                        <div class="d-flex align-items-center flex-grow-1">
                                            <div class="rounded-circle account-icon-container p-2 me-3 flex-shrink-0">
                                                <i class="fas fa-university text-white"></i>
                                            </div>
                                            <div class="flex-grow-1 min-width-0">
                                                <h6 class="mb-1 fw-bold text-dark text-truncate">{{item?.bank?.name}}</h6>
                                                <div class="d-flex align-items-center flex-wrap gap-1">
                                                    <small class="text-muted">{{item?.payment_method?.name}}</small>
                                                    <span class="empresa-tag ms-1" [ngClass]="item | empresaCuentaClase" [title]="item | empresaCuenta">{{ item | empresaCuentaClase | uppercase }}</span>
                                                    <span class="badge bg-info" *ngIf="item?.tag">{{item?.tag}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-end flex-shrink-0 ms-2">
                                            <span class="badge"
                                                  [ngClass]="account?.code == item?.code ? 'bg-success' : 'bg-secondary-subtle text-secondary'">
                                                <i class="fas" [ngClass]="account?.code == item?.code ? 'fa-check' : 'fa-circle'"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <!-- Información principal - Vertical Layout -->
                                    <div class="mb-3">
                                        <!-- Moneda -->
                                        <div class="d-flex align-items-center mb-2">
                                            <i class="fas fa-coins text-primary me-2 flex-shrink-0"></i>
                                            <div class="min-width-0">
                                                <small class="text-muted d-block">Moneda</small>
                                                <span class="fw-bold text-truncate"
                                                      [ngClass]="item?.currency?.code === 'USD' ? 'text-success' : 'text-warning'">
                                                    {{item?.currency?.name}}
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Número de cuenta -->
                                        <div class="d-flex align-items-center mb-2" *ngIf="item?.number">
                                            <i class="fas fa-credit-card text-primary me-2 flex-shrink-0"></i>
                                            <div class="min-width-0">
                                                <small class="text-muted d-block">Número</small>
                                                <span class="fw-bold text-dark text-truncate">{{item?.number}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Información adicional - Vertical Layout -->
                                    <div *ngIf="item?.taxId || item?.phone || item?.email">
                                        <!-- RIF -->
                                        <div class="d-flex align-items-center mb-2" *ngIf="item?.taxId">
                                            <i class="fas fa-id-card text-primary me-2 flex-shrink-0"></i>
                                            <div class="min-width-0">
                                                <small class="text-muted d-block">RIF</small>
                                                <span class="fw-medium text-dark text-truncate">{{item?.taxId}}</span>
                                            </div>
                                        </div>

                                        <!-- Teléfono -->
                                        <div class="d-flex align-items-center mb-2" *ngIf="item?.phone">
                                            <i class="fas fa-phone text-primary me-2 flex-shrink-0"></i>
                                            <div class="min-width-0">
                                                <small class="text-muted d-block">Teléfono</small>
                                                <span class="fw-medium text-dark text-truncate">{{item?.phone}}</span>
                                            </div>
                                        </div>

                                        <!-- Email -->
                                        <div class="d-flex align-items-center mb-2" *ngIf="item?.email">
                                            <i class="fas fa-envelope text-primary me-2 flex-shrink-0"></i>
                                            <div class="min-width-0">
                                                <small class="text-muted d-block">Email</small>
                                                <span class="fw-medium text-dark text-truncate">{{item?.email}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Indicador de selección -->
                                    <div class="border-top pt-2 mt-3" *ngIf="account?.code == item?.code">
                                        <div class="d-flex align-items-center justify-content-center">
                                            <i class="fas fa-check-circle text-success me-2"></i>
                                            <span class="text-success fw-bold small">Cuenta Seleccionada</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</ng-template>
<ng-template #view1 let-data>
    <div class="mt-4">
        <!-- Mensaje cuando no se ha seleccionado tipo de producto -->
        <div class="alert alert-info d-flex align-items-center mb-4" *ngIf="!isProductTypeSelected">
            <i class="fas fa-info-circle me-2"></i>
            <div>
                <strong>Selecciona un tipo de producto</strong>
                <div class="small mt-1">Primero debes seleccionar un tipo de producto antes de poder elegir una cuenta destino.</div>
            </div>
        </div>

        <!-- Selección de cuenta con diseño mejorado - Solo se muestra si hay tipo de producto seleccionado -->
        <div class="card border-0 shadow-sm mb-4" *ngIf="isProductTypeSelected">
            <div class="card-header bg-gradient text-white border-0 py-3" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                <div class="d-flex align-items-center">
                    <i class="fas fa-university me-2"></i>
                    <h6 class="mb-0 fw-bold">Cuenta de Destino</h6>
                </div>
            </div>
            <div class="card-body p-4" (click)="openview(optonsAcciones)" style="cursor: pointer;">
                <ng-container *ngIf="!account">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center">
                            <div class="rounded-circle bg-light p-3 me-3">
                                <i class="fas fa-plus text-primary"></i>
                            </div>
                            <div>
                                <span class="fw-medium text-dark">Seleccione la cuenta destino</span>
                                <div class="text-muted small">Toque aquí para elegir una cuenta</div>
                            </div>
                        </div>
                        <i class="fas fa-chevron-right text-primary" style="font-size: 18px;"></i>
                    </div>
                </ng-container>

                <ng-container *ngIf="account">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="d-flex align-items-center flex-grow-1">
                            <div class="rounded-circle bg-gradient p-3 me-3 flex-shrink-0"
                                 style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                                <i class="fas fa-university text-white"></i>
                            </div>
                            <div class="flex-grow-1 min-width-0">
                                <h6 class="mb-1 fw-bold text-dark">{{account?.bank?.name}}</h6>
                                <div class="d-flex align-items-center flex-wrap gap-2 mb-2">
                                    <span class="badge bg-info-subtle text-info">{{account?.payment_method?.name}}</span>
                                    <span class="empresa-tag ms-1" [ngClass]="account | empresaCuentaClase" [title]="account | empresaCuenta">{{ account | empresaCuentaClase | uppercase }}</span>
                                    <span class="badge bg-primary" *ngIf="account?.tag">{{account?.tag}}</span>
                                </div>

                                <!-- Información de la cuenta en formato vertical profesional -->
                                <div class="account-details">
                                    <div class="detail-item" *ngIf="account?.currency">
                                        <i class="fas fa-coins text-primary me-2"></i>
                                        <span class="label">Moneda:</span>
                                        <span class="value fw-medium" [ngClass]="account?.currency?.code === 'USD' ? 'text-success' : 'text-warning'">
                                            {{account?.currency?.name}}
                                        </span>
                                    </div>

                                    <div class="detail-item" *ngIf="account?.number">
                                        <i class="fas fa-credit-card text-primary me-2"></i>
                                        <span class="label">Número:</span>
                                        <span class="value fw-medium">{{account?.number}}</span>
                                    </div>

                                    <div class="detail-item" *ngIf="account?.taxId">
                                        <i class="fas fa-id-card text-primary me-2"></i>
                                        <span class="label">RIF:</span>
                                        <span class="value fw-medium">{{account?.taxId}}</span>
                                    </div>

                                    <div class="detail-item" *ngIf="account?.phone">
                                        <i class="fas fa-phone text-primary me-2"></i>
                                        <span class="label">Teléfono:</span>
                                        <span class="value fw-medium">{{account?.phone}}</span>
                                    </div>

                                    <div class="detail-item" *ngIf="account?.email">
                                        <i class="fas fa-envelope text-primary me-2"></i>
                                        <span class="label">Email:</span>
                                        <span class="value fw-medium">{{account?.email}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-end flex-shrink-0 ms-3">
                            <i class="fas fa-edit text-primary" style="font-size: 18px;"></i>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Mensaje de error para cuenta -->
        <div class="alert alert-danger d-flex align-items-center mb-4" *ngIf="!account && !this.form.pristine && isProductTypeSelected">
            <i class="fas fa-exclamation-triangle me-2"></i>
            <div>La cuenta es obligatoria</div>
        </div>
    </div>

    <ng-container *ngIf="account">


        <div class=" mt-4 mb-3 ">

            <ng-container *ngIf="rate_load ">
                <div class="alert alert-secondary p-2" style="background-color: #f8d7da3b" role="alert">
                    <span class="text-dark small">Consultando tasa (BCV)... </span>
                </div>
            </ng-container>

            <!-- Mensaje de búsqueda automática BDV -->
            <ng-container *ngIf="account?.workflow === 'workflow_verificacion_bdv' && simplifiedFlow.loading">
                <div class="alert alert-info p-3 mb-3 border-0" style="background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%);">
                    <div class="d-flex align-items-center">
                        <div class="spinner-border spinner-border-sm text-info me-3" role="status">
                            <span class="visually-hidden">Buscando...</span>
                        </div>
                        <div>
                            <div class="fw-bold text-info mb-1">🔍 Buscando pagos automáticamente</div>
                            <div class="small text-dark">Verificando si existe un pago con los datos proporcionados...</div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="!rate_load && !rate_error">

                <!--   <div *ngIf="pec()">
                    <div class="alert alert-danger p-2" style="background-color: #f8d7da3b" role="alert">

                        <span class="text-dark">Pago excedido  </span>

                       <span class="text-danger" *ngIf="account?.currency?.code == 'BS'">{{ pexe() | currency:'USD':'': '1.2-2'}} BS</span>
                        <span class="text-danger" *ngIf="account?.currency?.code != 'BS'">{{ pexe()  | currency:'USD':'': '1.2-2'}} USD</span>


                        <span class="text-danger" *ngIf="account?.currency?.code == 'BS'">{{ amountFB_bs | currency:'USD':'': '1.2-2'}} BS</span>
                        <span class="text-danger" *ngIf="account?.currency?.code != 'BS'">{{ amountFB | currency:'USD':'': '1.2-2'}} USD</span>

                        <div class="small mt-2 mb-2">
                            En caso de haber excedido pago del monto total de la cuota, dicho monto sera aplicado a otra cuota faltante cuando sea conciliado dicho pago.
                            <a href=""> Politicas de pago</a>
                        </div>
                    </div>
                </div>-->

                <div>
                    <div *ngIf="!paymentEdit && !multipago">
                        <span class="text-dark">Pago pendiente  </span>
                        <span *ngIf="account?.currency?.code === 'BS'">{{  amountFB_bs | currency:'USD':'': '1.2-2'}} BS</span>
                        <span *ngIf="account?.currency?.code !== 'BS'">{{  amountFB | currency:'USD':'': '1.2-2'}} USD</span>

                        <div *ngIf="account?.currency?.code !== 'BS'">
                            <span class="text-secondary fz-12 fw-bold ">
                                IGTF Incluido
                                <span class="text-dark">3%</span>
                            </span>

                        </div>
                    </div>

                    <div class="fz-12 text-secondary" *ngIf=" remanente?.payment_status_remante">Remanente de {{remanente?.remaining_amount}} USD incluido</div>

                    <div class="mt-4" *ngIf="account?.currency?.code === 'BS'">
                        <div class="text-start p-3" style="background-color: #f8f9fa; border-radius: 8px; border: 1px solid #dee2e6;">
                            <span class="text-muted" style="font-size: 18px;">Tasa de cambio: </span>
                            <span style="font-size: 18px; font-weight: bold; color: #333;">USD 1 = BS {{rate?.amount | currency:'USD':'': '1.2-2'}}</span>
                        </div>
                    </div>
                </div>
            </ng-container>


        </div>



        <!-- Sección de Fecha de Pago Mejorada -->
        <div class="mt-4">
            <label class="form-label fw-medium mb-3">
                <i class="fas fa-calendar-alt me-2 text-primary"></i>
                Fecha de pago
            </label>
            
            <!-- Botones de selección de fecha -->
            <div class="d-flex gap-2 mb-3 flex-wrap">
                <button 
                    type="button" 
                    class="btn btn-sm d-flex align-items-center"
                    [class.btn-primary]="dateOption === 'today'"
                    [class.btn-outline-primary]="dateOption !== 'today'"
                    (click)="setDateOption('today')"
                >
                    <i class="fas fa-clock me-1"></i>
                    Hoy
                </button>
                <button 
                    type="button" 
                    class="btn btn-sm d-flex align-items-center"
                    [class.btn-secondary]="dateOption === 'yesterday'"
                    [class.btn-outline-secondary]="dateOption !== 'yesterday'"
                    (click)="setDateOption('yesterday')"
                >
                    <i class="fas fa-calendar-minus me-1"></i>
                    Ayer
                </button>
                <button 
                    type="button" 
                    class="btn btn-sm d-flex align-items-center"
                    [class.btn-info]="dateOption === 'custom'"
                    [class.btn-outline-info]="dateOption !== 'custom'"
                    (click)="setDateOption('custom')"
                >
                    <i class="fas fa-calendar-alt me-1"></i>
                    Otra fecha
                </button>
        </div>
            
            <!-- Mostrar fecha seleccionada cuando es Hoy o Ayer -->
            <div *ngIf="dateOption === 'today' || dateOption === 'yesterday'" class="mb-3">
                <div class="form-control d-flex align-items-center bg-light">
                    <i class="fas fa-calendar me-2 text-muted"></i>
                    <span class="fw-medium">{{date_base | date: 'dd/MM/yyyy'}}</span>
                    <span class="ms-2 text-muted small">({{dateOption === 'today' ? 'Hoy' : 'Ayer'}})</span>
                </div>
            </div>
            
            <!-- Selector de fecha personalizada (solo cuando se selecciona "Otra fecha") -->
            <div *ngIf="dateOption === 'custom'">
                <div class="d-block d-md-none">
                    <mbsc-date 
                        (onSet)="dateSet($event)" 
                        [(ngModel)]="date_base" 
                        [options]="mobileSettings" 
                        placeholder="dd/mm/aaaa">
                        Seleccionar fecha
                    </mbsc-date>
                </div>
                <div class="d-none d-md-block">
                    <mbsc-date 
                        (onSet)="dateSet($event)" 
                        [(ngModel)]="date_base" 
                        [options]="desktopSettings" 
                        placeholder="dd/mm/aaaa">
                        Seleccionar fecha
                    </mbsc-date>
                </div>
            </div>
        </div>

        <div *ngIf="rate_error" class="text-danger small p-1 ">
            Error al consultar tasa (BCV) a esta fecha
        </div>

    </ng-container>










    <form *ngIf="!rate_error" autocomplete="nope" novalidate [formGroup]="form" class="text-start">


        <!-- Sección de teléfono mejorada con opciones -->
        <div *ngIf="account?.payment_method.code == 'PAGO_MOVIL' && account?.type_customer != 'CUSTOMER'" class="form-group col-12 mt-4">
            <label class="form-label fw-medium mb-3">
                <i class="fas fa-phone me-2 text-primary"></i>
                Teléfono desde donde realizo el pago
            </label>
            
            <!-- Botones de selección de teléfono -->
            <div class="d-flex gap-2 mb-3 flex-wrap">
                <button 
                    type="button" 
                    class="btn btn-sm d-flex align-items-center"
                    [class.btn-primary]="phoneOption === 'default'"
                    [class.btn-outline-primary]="phoneOption !== 'default'"
                    (click)="setPhoneOption('default')"
                    [disabled]="!person?.person?.phone"
                >
                    <i class="fas fa-user me-1"></i>
                    Usar mi número
                </button>
                <button 
                    type="button" 
                    class="btn btn-sm d-flex align-items-center"
                    [class.btn-secondary]="phoneOption === 'custom'"
                    [class.btn-outline-secondary]="phoneOption !== 'custom'"
                    (click)="setPhoneOption('custom')"
                >
                    <i class="fas fa-edit me-1"></i>
                    Usar otro número
                </button>
            </div>
            
            <!-- Mostrar teléfono por defecto cuando está seleccionado -->
            <div *ngIf="phoneOption === 'default' && person?.person?.phone" class="mb-3">
                <div class="form-control d-flex align-items-center bg-light">
                    <i class="fas fa-phone me-2 text-muted"></i>
                    <span class="fw-medium">{{formatPhoneDisplay(person.person.phone)}}</span>
                    <span class="ms-2 text-muted small">(Mi número registrado)</span>
                </div>
            </div>
            
            <!-- Campos de entrada manual (solo cuando se selecciona "Usar otro número") -->
            <div *ngIf="phoneOption === 'custom'">
                <div class="row">
                    <!-- Select del código de operadora -->
                    <div class="col-4">
                        <div class="form-floating">
                            <select [ngClass]="{'error': form.controls.code_phone.invalid && form.controls.code_phone.dirty}" 
                                    class="form-select" 
                                    id="code_phone" 
                                    formControlName="code_phone" 
                                    aria-label="Código de operadora">
                                <option value="">Código</option>
                                <option value="0414">0414</option>
                                <option value="0424">0424</option>
                                <option value="0412">0412</option>
                                <option value="0422">0422</option>
                                <option value="0416">0416</option>
                                <option value="0426">0426</option>
                     </select>
                            <label for="code_phone">Código</label>
                </div>
                    </div>
                    <!-- Input del número -->
                    <div class="col-8">
                        <div class="form-floating">
                            <input (keyup)="validatePhone()" 
                                   type="text" 
                                   [ngClass]="{'error': form.controls.phone.invalid && form.controls.phone.dirty}" 
                                   class="form-control" 
                                   id="phone" 
                                   formControlName="phone" 
                                   placeholder="1234567"
                                   maxlength="7">
                            <label for="phone">Número</label>
                        </div>
                    </div>
                    </div>
                </div>
            </div>




        <div class="row mt-2" *ngIf="account">
           


            <div *ngIf="account?.payment_method.code == 'TRANSFERENCIA' && account?.bank?.name != 'Zelle' && account?.type_customer != 'CUSTOMER'" class="form-group  col-12  mt-4">
                <label for="floatingref">Últimos 6 digitos del número de cuenta desde donde realizo el pago</label>

            </div>

            <div *ngIf="account?.payment_method.code == 'TRANSFERENCIA' && account?.bank?.name != 'Zelle' && account?.type_customer != 'CUSTOMER'" class="form-group  col-12  mt-3">

                <div class="form-floating mb-2">
                    <input (keyup)="validateAccountNumber()" [ngClass]="{'error': form.controls.accountNumber.invalid && form.controls.accountNumber.dirty}" formControlName="accountNumber" type="text" class="form-control" id="floatingref" placeholder="name@example.com">

                    <label for="floatingref">

                        <span>
                            Número de cuenta (últimos 6)
                        </span>
                    </label>
                </div>

                <div class="form-control-feedback help-block" *ngIf="form.get('accountNumber').errors">
                    <div *ngIf="form.get('accountNumber').errors['required'] && !form.get('accountNumber').pristine">
                        Campo requerido
                    </div>
                </div>

                <div *ngIf="!form.pristine && !validationAccountNumber" class="form-control-feedback help-block ">

                    Ingrese los últimos 6 digitos del número de cuenta
                </div>


            </div>

            <ng-container *ngIf="account">
                <div class="form-group  col-12  mt-3">
                    <!-- maxDuelbalance : {{maxDuelbalance()}} -->

                    <div class="form-floating ">
                        <input currencyMask (click)="moveCursorToEnd($event); validateTotalAmountMin()" [options]="{ prefix:account?.currency?.code+' ', thousands: ',', decimal: '.' }" type="text" [placeholder]="((amountF) | currency:'USD':'': '1.2-2') + 'USD'" (keyup)="changeMount(); validateTotalAmountMin()" [ngClass]="{'error': form.controls.total_amount.invalid && form.controls.total_amount.dirty}"
                            class="form-control text-capitalize" id="floatingmt" formControlName="total_amount">
                        <label for="floatingmt" class=" label font-weight-normal" style="word-wrap: break-word;">
                        <span >Monto Total </span>




             </label>
                    </div>


                        <!-- <div class="form-control-feedback help-block" *ngIf="!validationMinAmount">
                                <div>
                                    Monto debe ser mayor a {{ minAmount }}
                                </div>
                        </div> -->

                        <div class="form-control-feedback help-block" *ngIf="form.get('total_amount').errors ">

                            <div *ngIf="form.get('total_amount').errors['required'] && !form.pristine">
                                Campo requerido
                            </div>

                            <div *ngIf="form.get('total_amount').errors['pattern']  && !form.pristine">
                                Monto inválido
                            </div>


                            <div class="form-control-feedback help-block" *ngIf="!(this.form?.getRawValue()?.total_amount > 0) && !form.pristine">
                                <div>
                                    Monto debe ser mayor a 0
                                </div>
                            </div>

                        </div>


<!--
                    <div class="form-control-feedback help-block" *ngIf="maxDuelbalance() ">
                        <div>
                            Monto maximo superado
                        </div>

                    </div>

-->

                    <!-- <div class="form-control-feedback help-block" *ngIf="pec() && !form.pristine">
                        <b> Monto Exedido</b> <br> En caso de haber excedido pago del monto total de la cuota, dicho monto sera aplicado a otra cuota faltante cuando sea conciliado dicho pago.
                    </div> -->

                </div>




                <div class="form-group  col-12  mt-3"  *ngIf="account?.type_customer != 'CUSTOMER' && (account?.workflow !== 'workflow_verificacion_bdv' || (simplifiedFlow.verification.matches !== null && simplifiedFlow.verification.matches !== 'unique'))">
                    <div class="form-floating mb-2">


                        <ng-container  *ngIf="account?.bank?.name == 'Zelle'" >
                            <input [ngClass]="{'error': form.controls.reference.invalid && form.controls.reference.dirty}" formControlName="reference" type="text" class="form-control" id="floatingref"  placeholder="name@example.com">
                        </ng-container>

                        <ng-container  *ngIf="account?.bank?.name != 'Zelle'" >
                            <input (keypress)="validateNumericInput($event); validateNumberReference(this.reference_length, this.reference_length_max)"  (keyup)="validateNumericInput($event); validateNumberReference(this.reference_length, this.reference_length_max)" [ngClass]="{'error': form.controls.reference.invalid && form.controls.reference.dirty}" formControlName="reference" type="text" class="form-control" id="floatingref" [minlength]="reference_length"
                            [maxlength]="reference_length_max" placeholder="name@example.com" [pattern]="'^\\d*$'">
                        </ng-container>





                        <label for="floatingref">
                            <span  *ngIf="account?.bank?.name == 'Zelle'" >
                                Concepto colocado al realizar en la transacción
                            </span>

                            <span  *ngIf="(account?.bank?.name != 'Zelle' ) ">
                                <span>
                                    Ultimos {{ this.reference_length }} digitos de la referencia del pago                                </span>
                            </span>


                        </label>
                    </div>

                    <div class="form-control-feedback help-block" *ngIf="form.get('reference').errors">
                        <div *ngIf="form.get('reference').errors['required'] && !form.get('reference').pristine">
                            Campo requerido
                        </div>
                        <div *ngIf="form.controls.reference.errors?.minlength">Debe tener al menos {{reference_length}} caracteres.</div>
                        <div *ngIf="form.controls.reference.errors?.maxlength">No puede tener más de {{reference_length_max}} caracteres.</div>
                        <div *ngIf="form.controls.reference.errors?.pattern">Solo se permiten números.</div>
                    </div>


                    <!-- <span *ngIf="(account?.bank?.name != 'Zelle' &&  account?.payment_method.code != 'TRANSFERENCIA') ">
                        Ingrese la referencia
                    </span> -->

                </div>





                <div class="form-group  col-12  mt-3" *ngIf=" account?.type_customer != 'CUSTOMER'">
                    <label for="floatingref" *ngIf="account?.payment_method.code == 'TRANSFERENCIA' ">Identificación del dueño de la cuenta</label>
                </div>


                <div class="form-group  col-4  mt-1" *ngIf="account?.payment_method.code == 'TRANSFERENCIA' && account?.type_customer != 'CUSTOMER'">
                    <div class="form-floating">
                        <select [ngClass]="{'error': form.controls.code_identity.invalid && form.controls.code_identity.dirty}" class="form-select" id="code_identity" formControlName="code_identity" aria-label="Floating label select example">
                            <option  value="">Selecione</option>
                            <option  value="V">V</option>
                            <option  value="J">J</option>
                            <option  value="E">E</option>
                            <option  value="P">P</option>
                         </select>
                        <label for="code_identity">Tipo</label>
                    </div>

                    <div class="form-control-feedback help-block" *ngIf="form.get('code_identity').errors">
                        <div *ngIf="form.get('code_identity').errors['required'] && !form.get('code_identity').pristine">
                            Campo requerido
                        </div>
                    </div>
                </div>

                <div class="form-group  col-8  mt-1" *ngIf="account?.payment_method.code == 'TRANSFERENCIA' && account?.type_customer != 'CUSTOMER'">

                    <div class="form-floating ">
                        <input type="text" [ngClass]="{'error': form.controls.identity.invalid && form.controls.identity.dirty}" class="form-control text-capitalize" id="identity" formControlName="identity" (keypress)="onlyNumbers($event)" (paste)="onPasteNumbers($event)">
                        <label for="identity" class=" label font-weight-normal" style="word-wrap: break-word;">
              <span >Documento </span>
         </label>
                    </div>

                </div>


                <div class="form-group  col-12  mt-2" *ngIf="account?.bank?.name != 'Zelle' && account?.payment_method.code != 'DEPOSITO_USD' && account?.payment_method.code != 'DEPOSITO_BS' && account?.type_customer != 'CUSTOMER' && (account?.workflow !== 'workflow_verificacion_bdv' || (simplifiedFlow.verification.matches !== null && simplifiedFlow.verification.matches !== 'unique' && !(simplifiedFlow.verification.matches === 'multiple' && !simplifiedFlow.data.paymentToken)))">
                    <div class="form-floating">
                        <select [ngClass]="{'error': form.controls.origin_account.invalid && form.controls.origin_account.dirty}" class="form-select" id="origin_account" formControlName="origin_account" aria-label="Floating label select example">
                            <option  selected value="">Selecione una opción</option>
    
                            <option *ngFor="let item of banks; let i=index" [value]="item?.bankCode" >
    
                                {{ item.name }}
    
                            </option>

                         </select>
                        <label for="origin_account">Cuenta origen</label>
                    </div>

                    <div class="form-control-feedback help-block" *ngIf="form.get('origin_account').errors">
                        <div *ngIf="form.get('origin_account').errors['required'] && !form.get('origin_account').pristine">
                            Campo requerido
                </div>
                    </div>
                </div>

                <!-- <div class="form-group  mt-4">
                    <div class="form-floating">
                        <textarea [ngClass]="{'error': form.controls.description.invalid && form.controls.description.dirty}" class="form-control text-capitalize" id="description" formControlName="description" placeholder="Leave a comment here" id="floatingTextarea2" style="height: 100px"></textarea>
                        <label for="floatingTextarea2">Descripción</label>
                    </div>
                </div> -->

            </ng-container>
        </div>
    </form>


    <!-- Campo de adjuntar archivo: Oculto por defecto en vista 2, solo visible cuando específicamente se requiere -->
    <ng-container *ngIf="account && !rate_error && account?.type_customer != 'CUSTOMER' && selectView === 1">

        <div class=" mt-4">
            <mbsc-input [options]="mobileSettingsFile" (change)="onFileSelected($event)" type="file" placeholder="Adunte el soporte...">Adjunte el soporte</mbsc-input>
        </div>

        <div class="form-control-feedback help-block">
            <div *ngIf="!this.formDataUpload && !paymentEdit"  >
                El xlsx adjunto es obligatorio
            </div>


        </div>
    </ng-container>

</ng-template>


<ng-template #view2 let-data>
    <div class="text-secondary2 ">

        <!-- Botón Volver -->
        <div class="mb-3">
            <button (click)="backStep()"
                    class="btn btn-outline-primary btn-sm d-flex align-items-center">
                <i class="fas fa-arrow-left me-2"></i>
                Volver
            </button>
        </div>

        <ng-container>

            <div class="mb-4 text-center">

                Información del pago

            </div>

            <!-- Indicador de pago detectado automáticamente -->
            <div class="mb-3" *ngIf="account?.workflow === 'workflow_verificacion_bdv' && simplifiedFlow.data.paymentToken">
                <div class="alert alert-success border-0 shadow-sm" style="background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);">
                    <div class="d-flex align-items-center">
                        <div class="me-3">
                            <i class="fas fa-magic text-success" style="font-size: 1.5rem;"></i>
                        </div>
                        <div class="flex-grow-1">
                            <h6 class="mb-1 text-success fw-bold">
                                <i class="fas fa-check-circle me-2"></i>
                                Pago Detectado Automáticamente
                            </h6>
                            <small class="text-success-emphasis">
                                El sistema ubicó tu transacción de forma automática. No es necesario adjuntar comprobante.
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mb-4 text-center" *ngIf="account?.payment?.typeTransaction==='PENDING'">


            </div>



            <div class="mb-3 text-dark">

              Cuenta destino

            </div>

            <div class="d-flex ">
                <div>
                    <div>
                        {{account?.bank?.name}}
                    </div>

                    <div class="fz-12">
                        {{account?.payment_method?.name}} /
                        <span class=" " *ngIf="account?.number">
                            {{account?.number}}
                        </span>

                        <span class="" *ngIf="account?.phone">
                            {{account?.phone}}
                        </span>

                    </div>

                </div>
                <div class=" ms-auto text-dark fw-bold">
                    {{form?.getRawValue()?.total_amount.toFixed(2)  }} {{account?.currency?.name}}
                </div>
            </div>

            <div class="mb-3 mt-4 text-dark">



            </div>


            <div class="mb-3 mt-4 text-dark">

                Detalle

            </div>



            <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.origin_account">
                <div>
                    Codigo de cuenta origen
                </div>
                <div class="ms-auto fw-bold">
                    {{form?.getRawValue()?.origin_account}}
                </div>
            </div>



            <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.identity">
                <div>
                    Identificación
                </div>
                <div class=" ms-auto fw-bold">
                    {{form?.getRawValue()?.code_identity}}-{{form?.getRawValue()?.identity}}
                </div>
            </div>


            <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.accountNumber">
                <div>
                    Últimos 6 digitos del número de cuenta
                </div>
                <div class="ms-auto fw-bold">
                    {{form?.getRawValue()?.accountNumber}}
                </div>
            </div>

            <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.phone">
                <div>
                   Teléfono
                </div>
                <div class="ms-auto fw-bold">
                    {{form?.getRawValue()?.code_phone}}  {{form?.getRawValue()?.phone}}
                </div>
            </div>

            <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.reference">
                <div>
                   Referencia
                </div>
                <div class="ms-auto fw-bold">
                    {{form?.getRawValue()?.reference}}
                </div>
            </div>





        <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.description">
            <div>
                Descripción
            </div>
            <div class="ms-auto ">

                {{form?.getRawValue()?.description}}
            </div>
        </div>

    </ng-container>

    </div>
</ng-template>


<ng-template #view4 let-data>

    <!-- ================================================================ -->
    <!-- WIDGET MODE: Rich payment detail view                            -->
    <!-- ================================================================ -->
    <ng-container *ngIf="isWidgetMode">
        <div class="card border-0 shadow-sm">
            <div class="card-body p-4">

                <!-- Status header -->
                <div class="text-center mb-4">
                    <div class="mb-3">
                        <i *ngIf="responseTransaction?.type === 'MANUAL' || responseTransaction?.type === 'PENDING'"
                           class="fas fa-clock fa-3x text-warning"></i>
                        <i *ngIf="responseTransaction?.type === 'AUTO' && responseTransaction?.status === 'A'"
                           class="fas fa-check-circle fa-3x text-success"></i>
                        <i *ngIf="responseTransaction?.type === 'AUTO' && responseTransaction?.status === 'R'"
                           class="fas fa-times-circle fa-3x text-danger"></i>
                    </div>
                    <h5 class="fw-bold mb-1">Pago Registrado</h5>
                    <div>
                        <span class="badge text-bg-warning" *ngIf="responseTransaction?.type === 'MANUAL'">En espera</span>
                        <span class="badge text-bg-info" *ngIf="responseTransaction?.type === 'PENDING'">Validando</span>
                        <span class="badge text-bg-success" *ngIf="responseTransaction?.type === 'AUTO' && responseTransaction?.status === 'A'">Aprobado</span>
                        <span class="badge text-bg-danger" *ngIf="responseTransaction?.type === 'AUTO' && responseTransaction?.status === 'R'">Rechazado</span>
                    </div>
                </div>

                <!-- Payment code -->
                <div class="bg-light rounded p-3 mb-4 text-center" *ngIf="responseTransaction?.payment?.code">
                    <small class="text-muted d-block">Código del pago</small>
                    <span class="fw-bold text-dark" style="font-size: 0.85rem; word-break: break-all;">{{responseTransaction?.payment?.code}}</span>
                </div>

                <!-- Amount section -->
                <div class="border rounded p-3 mb-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="text-muted">Monto</span>
                        <span class="fw-bold fs-5 text-dark">
                            {{form?.getRawValue()?.total_amount}} {{account?.currency?.name}}
                        </span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center" *ngIf="responseTransaction?.payment?.amount">
                        <span class="text-muted">Monto USD</span>
                        <span class="fw-bold text-success">
                            $ {{responseTransaction?.payment?.amount | number:'1.2-2'}} USD
                        </span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center mt-1" *ngIf="responseTransaction?.payment?.rate">
                        <span class="text-muted">Tasa</span>
                        <span class="fw-medium text-dark">{{responseTransaction?.payment?.rate}}</span>
                    </div>
                </div>

                <!-- Detail rows -->
                <div class="mb-4">
                    <h6 class="fw-bold text-dark border-bottom pb-2 mb-3">
                        <i class="fas fa-info-circle text-primary me-2"></i>Detalle del pago
                    </h6>

                    <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="account?.bank?.name">
                        <span class="text-muted">Cuenta destino</span>
                        <span class="fw-medium text-dark text-end">
                            {{account?.bank?.name}}<br>
                            <small class="text-muted">{{account?.payment_method?.name}}</small>
                        </span>
                    </div>

                    <div class="d-flex justify-content-between py-2 border-bottom">
                        <span class="text-muted">Fecha del pago</span>
                        <span class="fw-medium text-dark">{{date_base_string}}</span>
                    </div>

                    <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="responseTransaction?.payment?.date">
                        <span class="text-muted">Fecha de registro</span>
                        <span class="fw-medium text-dark">{{responseTransaction?.payment?.date | date:'dd/MM/yyyy HH:mm'}}</span>
                    </div>

                    <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="form?.getRawValue()?.reference">
                        <span class="text-muted">Referencia</span>
                        <span class="fw-bold text-dark">{{form?.getRawValue()?.reference}}</span>
                    </div>

                    <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="form?.getRawValue()?.origin_account">
                        <span class="text-muted">Banco origen</span>
                        <span class="fw-medium text-dark">{{form?.getRawValue()?.origin_account}}</span>
                    </div>

                    <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="form?.getRawValue()?.identity">
                        <span class="text-muted">Cédula</span>
                        <span class="fw-medium text-dark">{{form?.getRawValue()?.code_identity}}-{{form?.getRawValue()?.identity}}</span>
                    </div>

                    <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="form?.getRawValue()?.phone">
                        <span class="text-muted">Teléfono</span>
                        <span class="fw-medium text-dark">{{form?.getRawValue()?.code_phone}} {{form?.getRawValue()?.phone}}</span>
                    </div>

                    <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="form?.getRawValue()?.accountNumber">
                        <span class="text-muted">Nro. cuenta</span>
                        <span class="fw-medium text-dark">{{form?.getRawValue()?.accountNumber}}</span>
                    </div>

                    <div class="d-flex justify-content-between py-2 border-bottom" *ngIf="typeProduct">
                        <span class="text-muted">Tipo de producto</span>
                        <span class="fw-medium text-dark">{{typeProduct}}</span>
                    </div>

                    <div class="d-flex justify-content-between py-2" *ngIf="form?.getRawValue()?.description">
                        <span class="text-muted">Descripción</span>
                        <span class="fw-medium text-dark text-end" style="max-width: 60%;">{{form?.getRawValue()?.description}}</span>
                    </div>
                </div>

                <!-- Action button -->
                <div class="d-grid mt-4">
                    <button class="btn btn-primary btn-lg" type="button" (click)="redirectTo()">
                        <i class="fas fa-plus me-2"></i>Registrar otro pago
                    </button>
                </div>

            </div>
        </div>
    </ng-container>

    <!-- ================================================================ -->
    <!-- ORIGINAL VIEW (non-widget mode)                                  -->
    <!-- ================================================================ -->
    <ng-container *ngIf="!isWidgetMode">
    <div class="text-secondary2 ">

        <ng-container>

            <div class="mb-4 text-center">
                Verificación del pago
            </div>

            <div class="mb-3 text-center" *ngIf="responseTransaction?.type==='PENDING'">
                <div class="alert alert-warning p-2" style="background-color: #f8d7da3b" role="alert">
                    <span class="text-dark small"><span class="font-weight-bold">El pago está siendo validado, por favor espere unos minutos.</span>
                    </span>
                </div>
            </div>


            <div class="mb-3">

                <span class="badge text-bg-warning " *ngIf=" responseTransaction?.type == 'MANUAL' ">Pago por conciliar</span>
                <span class="badge text-bg-danger" *ngIf="responseTransaction?.type == 'AUTO'  &&  responseTransaction?.status == 'R'">Pago rechazado</span>
                <span class="badge text-bg-success" *ngIf="responseTransaction?.type == 'AUTO'  &&  responseTransaction?.status == 'A'">Pago aprobado</span>

                <div class="mb-3 text-dark fz-12 mt-2" *ngIf="responseTransaction?.descripcion">
                    {{responseTransaction?.descripcion}}
                </div>

            </div>


            <div class="mb-3 text-dark">

                Cuenta destino

              </div>

              <div class="d-flex ">
                  <div>
                      <div>
                          {{account?.bank?.name}}
                      </div>

                      <div class="fz-12">
                          {{account?.payment_method?.name}} /
                          <span class=" " *ngIf="account?.number">
                              {{account?.number}}
                          </span>

                          <span class="" *ngIf="account?.phone">
                              {{account?.phone}}
                          </span>

                      </div>

                  </div>
                  <div class=" ms-auto text-dark fw-bold">
                      {{form?.getRawValue()?.total_amount.toFixed(2) }} {{account?.currency?.name}}
                  </div>
              </div>

              <div class="mb-3 mt-4 text-dark">



              </div>


              <div class="mb-3 mt-4 text-dark">

                  Detalle

              </div>



              <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.origin_account">
                  <div>
                      Codigo de cuenta origen
                  </div>
                  <div class="ms-auto fw-bold">
                      {{form?.getRawValue()?.origin_account}}
                  </div>
              </div>



              <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.identity">
                  <div>
                      Identificación
                  </div>
                  <div class=" ms-auto fw-bold">
                      {{form?.getRawValue()?.code_identity}}-{{form?.getRawValue()?.identity}}
                  </div>
              </div>


              <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.accountNumber">
                  <div>
                      Últimos 6 digitos del número de cuenta
                  </div>
                  <div class="ms-auto fw-bold">
                      {{form?.getRawValue()?.accountNumber}}
                  </div>
              </div>

              <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.phone">
                  <div>
                     Teléfono
                  </div>
                  <div class="ms-auto fw-bold">
                      {{form?.getRawValue()?.code_phone}}  {{form?.getRawValue()?.phone}}
                  </div>
              </div>

              <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.reference">
                  <div>
                     Referencia
                  </div>
                  <div class="ms-auto fw-bold">
                      {{form?.getRawValue()?.reference}}
                  </div>
              </div>





          <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.description">
              <div>
                  Descripción
              </div>
              <div class="ms-auto ">

                  {{form?.getRawValue()?.description}}
              </div>
          </div>



        </ng-container>


        <div class="d-flex mt-2" *ngIf="form?.getRawValue()?.description">
            <div>
                Descripción
            </div>
            <div class="ms-auto ">

                {{form?.getRawValue()?.description}}
            </div>
        </div>

        <div class="mb-3 mt-4 text-dark" *ngIf="responseTransaction?.voucher">
            Voucher
        </div>

        <div class="row" *ngIf="responseTransaction?.voucher">
            <div class="col-12 col-md-6">
                <div class="voucher p-2 text-dark text-uppercase" [innerHTML]="responseTransaction?.voucher">

                </div>

            </div>
        </div>

    </div>
    </ng-container>
</ng-template>











<ng-template #view5 let-data>
    <div class="conf">

        <ng-container *ngIf="account">

            <div class="titule-card-accion mt-4  text-capitalize text-primary w-100 fw-bold">
                {{account?.bank?.name}}
            </div>

            <div class="d-flex mt-4">
                <div class="text-secondary ">
                    Tipo
                </div>
                <div class="fw-bold  ms-auto">
                    {{account?.payment_method?.name}}
                </div>
            </div>

            <div class="d-flex mt-4">
                <div class="text-secondary ">
                    Moneda
                </div>
                <div class="fw-bold ms-auto">
                    {{account?.currency?.name}}
                </div>
            </div>
            <div class="d-flex mt-4" *ngIf="account?.taxId">
                <div class="text-secondary  ">
                    Rif
                </div>
                <div class="fw-bold ms-auto">
                    {{account?.taxId}}
                </div>
            </div>
            <div class="d-flex mt-4" *ngIf="account?.number">
                <div class="text-secondary  ">
                    Número
                </div>
                <div class="fw-bold fz-14 ms-auto">
                    {{account?.number}}
                </div>
            </div>

            <div class="d-flex mt-4" *ngIf="account?.phone">
                <div class="text-secondary  ">
                    Teléfono
                </div>
                <div class="fw-bold fz-14 ms-auto">
                    {{account?.phone}}
                </div>
            </div>

            <div class="d-flex mt-4" *ngIf="account?.email">
                <div class="text-secondary  ">
                    Email
                </div>
                <div class="fw-bold fz-14 ms-auto">
                    {{account?.email}}
                </div>
            </div>

        </ng-container>

        <div class="d-flex mt-4">
            <div>
                Monto Total </div>
            <div class="ms-auto text-start fw-bold">

                {{form?.getRawValue()?.total_amount}}
            </div>

        </div>


        <div class="d-flex mt-4">
            <div>
                Referencia
            </div>
            <div class="ms-auto text-start fw-bold" *ngIf="form?.getRawValue()?.reference">

                {{form?.getRawValue()?.reference}}
            </div>

        </div>


        <div class="d-flex mt-4">
            <div>
                Descripción
            </div>
            <div class="ms-auto text-start fw-bold" *ngIf="form?.getRawValue()?.description">

                {{form?.getRawValue()?.description}}
            </div>
        </div>
    </div>
</ng-template>

<ng-template #view3 let-data>

    <div class="h5 mt-4 mb-3">Ordern confirmada</div>

    <div class="conf">

        <ng-container *ngIf="account">

            <div class="titule-card-accion mt-4  text-capitalize text-primary w-100 fw-bold">
                {{account?.bank?.name}}
            </div>

            <div class="d-flex mt-4">
                <div class="text-secondary ">
                    Tipo
                </div>
                <div class="fw-bold  ms-auto">
                    {{account?.payment_method?.name}}
                </div>
            </div>

            <div class="d-flex mt-4">
                <div class="text-secondary ">
                    Moneda
                </div>
                <div class="fw-bold ms-auto">
                    {{account?.currency?.name}}
                </div>
            </div>
            <div class="d-flex mt-4" *ngIf="account?.taxId">
                <div class="text-secondary  ">
                    Rif
                </div>
                <div class="fw-bold ms-auto">
                    {{account?.taxId}}
                </div>
            </div>
            <div class="d-flex mt-4" *ngIf="account?.number">
                <div class="text-secondary  ">
                    Número
                </div>
                <div class="fw-bold fz-14 ms-auto">
                    {{account?.number}}
                </div>
            </div>

            <div class="d-flex mt-4" *ngIf="account?.phone">
                <div class="text-secondary  ">
                    Teléfono
                </div>
                <div class="fw-bold fz-14 ms-auto">
                    {{account?.phone}}
                </div>
            </div>

            <div class="d-flex mt-4" *ngIf="account?.email">
                <div class="text-secondary  ">
                    Email
                </div>
                <div class="fw-bold fz-14 ms-auto">
                    {{account?.email}}
                </div>
            </div>

        </ng-container>

        <div class="d-flex mt-4">
            <div>
                Monto Total </div>
            <div class="ms-auto text-start fw-bold">

                {{form?.getRawValue()?.total_amount}}
            </div>

        </div>


        <div class="d-flex mt-4">
            <div>
                Referencia
            </div>
            <div class="ms-auto text-start fw-bold" *ngIf="form?.getRawValue()?.reference">

                {{form?.getRawValue()?.reference}}
            </div>

        </div>


        <div class="d-flex mt-4">
            <div>
                Descripción
            </div>
            <div class="ms-auto text-start fw-bold" *ngIf="form?.getRawValue()?.description">

                {{form?.getRawValue()?.description}}
            </div>
        </div>

        <div class="d-flex mt-4 text-success">
            <div>
                Código del pago
            </div>
            <div class="ms-auto text-start fw-bold">
                {{ordernumber}}

            </div>

        </div>
    </div>
</ng-template>



<div class="container-fluid bg-light min-vh-100">
    <div class="max-w-full mx-auto px-4 py-4">
        <!-- Loading spinner -->
        <div class="row" *ngIf="loading">
            <div class="col-12">
                <div class="d-flex justify-content-center align-items-center" style="min-height: 60vh;">
                    <div class="text-center">
                        <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                        <h5 class="text-muted">Cargando información del cliente...</h5>
                        <p class="text-muted small mb-0">Por favor espera un momento</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!loading">
            <div class="col-12">
                <!-- Modern Customer Profile Bar -->
                <div class="bg-gray-50 py-4">
                    <div class="max-w-6xl mx-auto px-4">
                        <!-- Customer Profile Section (hidden in widget mode) -->
                        <div *ngIf="!isWidgetMode && !loading && person?.person" class="mb-4">
                            <div class="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                                <div class="flex items-center space-x-4">
                                    <div [routerLink]="['/console/person/profile/',person?.person?.code]"
                                         class="flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity">
                                        <img
                                            *ngIf="person?.person?.file_selfie"
                                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                                            [src]="sanitize(person?.person?.file_selfie?.url)"
                                            alt="Avatar del cliente"
                                        />
                                        <img
                                            *ngIf="!person?.person?.file_selfie && person?.person?.gender != 'F'"
                                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                                            [src]="sanitize('../assets/public/images/avatar.png')"
                                            alt="Avatar del cliente"
                                        />
                                        <img
                                            *ngIf="!person?.person?.file_selfie && person?.person?.gender == 'F'"
                                            class="w-16 h-16 rounded-full object-cover border-2 border-blue-600"
                                            [src]="sanitize('../assets/public/images/avatara-female.png')"
                                            alt="Avatar del cliente"
                                        />
                                    </div>
                                    <div class="flex-1">
                                        <h2 class="text-xl font-bold text-gray-900 capitalize">
                                            {{person?.person?.name}} {{person?.person?.lastName}}
                                        </h2>
                                        <div class="flex flex-wrap gap-4 mt-1 text-sm text-gray-600">
                                            <div class="flex items-center gap-1">
                                                <i class="fas fa-id-card text-blue-600"></i>
                                                <span
                                                    class="cursor-pointer hover:text-blue-800 transition-colors"
                                                    (click)="copyIdentityToClipboard(person)"
                                                    title="Clic para copiar cédula">
                                                    {{getIdentity(person)}}
                                                </span>
                                            </div>
                                            <div class="flex items-center gap-1">
                                                <i class="fas fa-phone text-blue-600"></i>
                                                <span
                                                    class="cursor-pointer hover:text-blue-800 transition-colors"
                                                    (click)="copyPhoneToClipboard(person)"
                                                    title="Clic para copiar número">
                                                    {{getContact(person)}}
                                                </span>
                                            </div>
                                            <div *ngIf="getEmailContact(person)" class="flex items-center gap-1">
                                                <i class="fas fa-envelope text-blue-600"></i>
                                                <span>{{getEmailContact(person)}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Input de código dinámico mejorado -->
                <!-- REMOVED: Dynamic code section as it will be handled automatically when selecting product -->

                <!-- Formulario principal -->
                <div class="row">
                    <div class="col-12 col-lg-8 col-xl-6 mx-auto text-dark mt-2">
                        <div class="card border-0 shadow-sm">
                            <div class="card-header bg-gradient text-white border-0 py-3" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                                <div class="d-flex align-items-center">
                                    <i class="fas fa-credit-card me-2"></i>
                                    <h6 class="mb-0 fw-bold">Información del Pago</h6>
                                </div>
                            </div>
                            <div class="card-body p-4">
                                <ng-container *ngIf="selectView == 1">
                                    <!-- Información de pago y fechas -->
                                    <div class="d-flex justify-content-between align-items-start mb-4" *ngIf="installment">
                                        <div>
                                            <h5 class="fw-bold text-dark mb-2">Registrar pago</h5>
                                            <div class="text-secondary fz-14">
                                                {{ installment?.invoice?.identifier}} / {{ installment?.order < 1 ? 'Inicial': 'cuota '+ installment?.order}}
                                            </div>
                                        </div>
                                        <div class="text-end">
                                            <div class="text-secondary small">Fecha de pago</div>
                                            <div class="fw-medium text-dark">{{installment?.scheduledPaymentDate | date: 'dd/MM/yyyy'}}</div>
                                        </div>
                                    </div>

                                    <!-- Selector de tipo de producto con autocompletar -->
                                    <div class="mb-4">
                                        <div class="mb-3">
                                            <h6 class="fw-bold text-dark mb-3">
                                                <i class="fas fa-tag me-2 text-primary"></i>
                                                Tipo de producto
                                            </h6>
                                            <p class="text-muted small mb-3">Busca y selecciona el tipo de producto para tu pago</p>
                                        </div>

                                        <!-- Buscador de productos con dropdown -->
                                        <div class="position-relative product-search-input">
                                            <div class="form-floating">
                                                <input
                                                    type="text"
                                                    class="form-control"
                                                    id="productSearch"
                                                    [(ngModel)]="productSearchTerm"
                                                    (input)="filterProducts()"
                                                    (focus)="showProductOptions()"
                                                    (blur)="hideProductOptions()"
                                                    placeholder="Buscar tipo de producto..."
                                                    autocomplete="off">
                                                <label for="productSearch">
                                                    <i class="fas fa-search me-2"></i>
                                                    Buscar tipo de producto
                                                </label>
                                                <!-- Botón limpiar -->
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-outline-secondary position-absolute end-0 top-50 translate-middle-y me-2"
                                                    *ngIf="productSearchTerm"
                                                    (click)="clearProductSearch()"
                                                    style="z-index: 10;">
                                                    <i class="fas fa-times"></i>
                                                </button>
                                            </div>

                                            <!-- Dropdown de productos -->
                                            <div
                                                class="product-search-dropdown"
                                                *ngIf="showProductDropdown && filteredProductArray.length > 0">

                                                <!-- Header del dropdown -->
                                                <div class="px-3 py-2 dropdown-header-info">
                                                    <small>
                                                        <i class="fas fa-list me-1"></i>
                                                        {{filteredProductArray.length}} producto{{filteredProductArray.length > 1 ? 's' : ''}} encontrado{{filteredProductArray.length > 1 ? 's' : ''}}
                                                    </small>
                                                </div>

                                                <!-- Lista de productos -->
                                                <div class="list-group list-group-flush">
                                                    <button
                                                        type="button"
                                                        class="list-group-item list-group-item-action d-flex align-items-center py-3"
                                                        *ngFor="let product of filteredProductArray; let i=index"
                                                        (click)="selectProduct(product)"
                                                        [ngClass]="{'selected': typeProduct === getProductDynamicCode(product)}">
                                                        <div class="me-3">
                                                            <i class="fas fa-cube text-primary fa-lg"></i>
                                                        </div>
                                                        <div class="flex-grow-1">
                                                            <h6 class="mb-1 fw-bold text-dark">{{ product?.params?.name || product?.name || product?.params?.code }}</h6>
                                                            <small class="text-muted">Código: {{ product?.params?.code }}</small>
                                                            <small class="text-muted d-block" *ngIf="product?.params?.dinamic_code?.[0]">
                                                                Etiqueta: {{ product?.params?.dinamic_code?.[0] }}
                                                            </small>
                                                        </div>
                                                        <div class="ms-2">
                                                            <i class="fas fa-chevron-right text-muted"></i>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>

                                            <!-- Mensaje cuando no hay resultados -->
                                            <div
                                                class="product-search-dropdown"
                                                *ngIf="showProductDropdown && filteredProductArray.length === 0 && productSearchTerm">
                                                <div class="no-results-message">
                                                    <i class="fas fa-search fa-2x"></i>
                                                    <h6 class="text-muted">No se encontraron productos</h6>
                                                    <small class="text-muted">Intenta con otro término de búsqueda</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Resumen de deuda con diseño profesional -->
                                    <div class="alert alert-info border-0 p-4 mb-4" *ngIf="concept_deduction_apply.length>0 && !paymentEdit && false" style="background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);">
                                        <div class="d-flex align-items-center mb-3">
                                            <i class="fas fa-exclamation-circle text-info me-2"></i>
                                            <h6 class="mb-0 fw-bold text-dark">Resumen de Deuda</h6>
                                        </div>

                                        <div class="debt-summary">
                                            <div class="d-flex justify-content-between py-2" *ngIf="person?.resumen?.monto_adeudado_vencido">
                                                <span class="fw-medium text-dark">Deuda acumulada</span>
                                                <span class="fw-bold text-secondary">{{ person?.resumen?.monto_adeudado_vencido.toFixed(2) }} USD</span>
                                            </div>

                                            <div class="border-top pt-2 mt-2">
                                                <div class="fee-item" *ngFor="let fee of concept_deduction_apply">
                                                    <div class="d-flex justify-content-between align-items-start py-2">
                                                        <div class="flex-grow-1">
                                                            <div class="fw-medium text-dark">{{ fee?.fee?.concept_deduction?.name }}</div>
                                                            <small class="text-muted">{{ fee?.invoice }} / Cuota {{ fee?.order }}</small>
                                                        </div>
                                                        <span class="fw-bold text-secondary">{{ fee?.amount_fee }} USD</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="border-top pt-3 mt-3">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <span class="h6 fw-bold text-dark mb-0">Total a Pagar</span>
                                                    <div class="text-end">
                                                        <div class="h5 fw-bold text-dark mb-0" *ngIf="account?.currency?.code == 'USD'">
                                                            {{ deuda_total | currency:'USD':'': '1.2-2' }} USD
                                                        </div>
                                                        <div class="h5 fw-bold text-dark mb-0" *ngIf="account?.currency?.code != 'USD'">
                                                            Bs. {{ (rate?.amount.toFixed(2) * (deuda_total)) | currency:'BS':'': '1.2-2' }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Botón cancelar mejorado -->
                                    <div class="d-flex justify-content-end mb-3" *ngIf="responseTransaction != true && paymentEdit">
                                        <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
                                            <i class="fas fa-times me-1"></i>
                                            Cancelar
                                        </button>
                                    </div>

                                 

                                    <!-- Contenido del formulario tradicional -->
                                        <ng-container *ngTemplateOutlet="view1"></ng-container>
                                </ng-container>

                                <ng-container *ngIf="selectView==4">
                                    <a *ngIf="!isWidgetMode && !paymentEdit && responseTransaction?.type != 'MANUAL' && responseTransaction?.status != 'A' && responseTransaction?.type!=='PENDING'" class="text-primary mb-2" (click)="selectView=1">volver</a>
                                    <ng-container *ngTemplateOutlet="view4"></ng-container>
                                </ng-container>

                                <ng-container *ngIf="selectView==2">
                                    <ng-container *ngTemplateOutlet="view2"></ng-container>
                                </ng-container>

                                <div class="mt-5 mb-5">
                                    <div class="col-12">
                                        <div class="d-grid gap-3">
                                            <ng-container *ngIf="!confirmLoading">
                                                <!-- Botón Siguiente mejorado -->
                                                <button *ngIf="selectView == 1 && !confirm || rate_error"
                                                    [disabled]="getBtnNextDisabled()"
                                                    class="btn btn-premium btn-lg"
                                                    type="button"
                                                    (click)="nextStep()">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <span *ngIf="simplifiedFlow.loading" class="spinner-border spinner-border-sm me-2"></span>
                                                        <i *ngIf="!simplifiedFlow.loading" class="fas fa-arrow-right me-2"></i>
                                                        <span class="fw-bold">
                                                            <!-- Texto dinámico según flujo BDV -->
                                                            <ng-container *ngIf="account?.workflow === 'workflow_verificacion_bdv' && selectView === 1 && simplifiedFlow.verification.matches === null">
                                                                <ng-container *ngIf="simplifiedFlow.loading">
                                                                    Buscando pagos...
                                                                </ng-container>
                                                                <ng-container *ngIf="!simplifiedFlow.loading">
                                                                    Verificar Pago
                                                                </ng-container>
                                                            </ng-container>
                                                            <ng-container *ngIf="account?.workflow !== 'workflow_verificacion_bdv' || selectView !== 1 || simplifiedFlow.verification.matches !== null">
                                                                Siguiente Paso
                                                            </ng-container>
                                                        </span>
                                                        <span class="ms-2 badge bg-light text-dark rounded-pill">{{selectView}}/{{selectMaxView}}</span>
                                                    </div>
                                                </button>

                                                <!-- Botón Confirmar mejorado -->
                                                <button *ngIf="selectView == 2 && !confirm"
                                                    [disabled]="getBtnConfirmDisabled()"
                                                    class="btn btn-success-premium btn-lg"
                                                    type="button"
                                                    (click)="nextStep()">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <i class="fas fa-check-circle me-2"></i>
                                                        <span class="fw-bold">Confirmar Pago</span>
                                                        <span class="ms-2 badge bg-light text-dark rounded-pill">{{selectView}}/{{selectMaxView}}</span>
                                                    </div>
                                                </button>

                                                <!-- Botón Continuar mejorado (hidden in widget mode, widget has own button) -->
                                                <button *ngIf="!isWidgetMode && (confirm && responseTransaction?.status == 'A' || responseTransaction?.type == 'MANUAL' || responseTransaction?.type==='PENDING')"
                                                    [disabled]="!this.formDataUpload && account?.type_customer != 'CUSTOMER' && !(account?.workflow === 'workflow_verificacion_bdv' && simplifiedFlow.data.paymentToken) && selectView === 1"
                                                    class="btn btn-success-premium btn-lg"
                                                    type="button"
                                                    (click)="redirectTo()">
                                                    <div class="d-flex align-items-center justify-content-center">
                                                        <i class="fas fa-check-double me-2"></i>
                                                        <span class="fw-bold">Continuar</span>
                                                    </div>
                                                </button>
                                            </ng-container>

                                            <!-- Estado de finalización -->
                                            <button *ngIf="responseTransaction === true"
                                                class="btn btn-success-premium btn-lg"
                                                type="button"
                                                (click)="goBack()">
                                                <div class="d-flex align-items-center justify-content-center">
                                                    <i class="fas fa-thumbs-up me-2"></i>
                                                    <span class="fw-bold">¡Finalizado!</span>
                                                </div>
                                            </button>

                                            <!-- Loading state mejorado -->
                                            <ng-container *ngIf="confirmLoading">
                                                <div class="w-100 text-center py-4">
                                                    <div class="d-flex align-items-center justify-content-center mb-3">
                                                        <div class="spinner-border text-primary me-3" role="status">
                                                            <span class="visually-hidden">Procesando...</span>
                                                        </div>
                                                        <div>
                                                            <h6 class="mb-1 text-dark">Procesando pago...</h6>
                                                            <small class="text-muted">Por favor espera un momento</small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
